import(/* webpackMode: "eager", webpackExports: ["DocumentUpload"] */ "/app/components/documents/document-upload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/components/layout/product-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
